<template>
  <div class="guideBox">
    <img src="/guide.png" alt="" @click="redemonstrate" />
  </div>
  <!-- <el-button
    class="guide-button"
    type="primary"
    icon="el-icon-video-camera"
    circle
    @click="redemonstrate"
  ></el-button> -->
</template>

<script>
export default {
  methods: {
    //重新演示
    redemonstrate() {
      this.$emit('againGuide');
    },
  },
};
</script>
<style scoped lang="scss">
.guide-button {
  position: fixed;
  top: 80%;
  right: 10px;
}
.guideBox {
  position: fixed;
  top: 80%;
  right: 10px;
  width: 40px;
  height: 40px;
  background-color: #1b72e3;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 50%;
    height: 50%;
  }
}
</style>
